exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-preview[data-v-f68b4764]{max-height:200px}", ""]);

// exports
